function limpar(valor) {
	return String(valor ?? "")
		.toUpperCase()
		.replace(/[^0-9A-Z]/g, "");
}

function todosIguais(valor) {
	return /^(.)\1+$/.test(valor);
}

function validarCpf(valor) {
	const cpf = limpar(valor);
	if (!/^\d{11}$/.test(cpf) || todosIguais(cpf)) return false;

	const digito = (base) => {
		const soma = [...base].reduce((acc, n, i) => acc + Number(n) * (base.length + 1 - i), 0);
		const resto = (soma * 10) % 11;
		return resto === 10 ? 0 : resto;
	};

	return digito(cpf.slice(0, 9)) === Number(cpf[9]) && digito(cpf.slice(0, 10)) === Number(cpf[10]);
}

function validarCnpj(valor) {
	const cnpj = limpar(valor);
	if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj) || todosIguais(cnpj)) return false;

	const digito = (base) => {
		const pesos = base.length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		const soma = [...base].reduce((acc, c, i) => acc + (c.charCodeAt(0) - 48) * pesos[i], 0);
		const resto = soma % 11;
		return resto < 2 ? 0 : 11 - resto;
	};

	return digito(cnpj.slice(0, 12)) === Number(cnpj[12]) && digito(cnpj.slice(0, 13)) === Number(cnpj[13]);
}

function validarCpfCnpj(valor) {
	const documento = limpar(valor);
	if (documento.length === 11) return validarCpf(documento);
	if (documento.length === 14) return validarCnpj(documento);
	return false;
}

function formatarCpfCnpj(valor) {
	const documento = limpar(valor);
	if (documento.length === 11) return documento.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
	if (documento.length === 14) return documento.replace(/^(\w{2})(\w{3})(\w{3})(\w{4})(\d{2})$/, "$1.$2.$3/$4-$5");
	return documento;
}

export { validarCpf, validarCnpj, validarCpfCnpj, formatarCpfCnpj };
